'use client';

import { c as _c } from "react/compiler-runtime";
import SvgVisible from '@common/icon/SvgVisible';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { readTappedThumbnail, rememberGiftPreview } from '@/app/_components/GiftCard/giftPreview';
import { NewBadge } from '@/app/donation/_components/NewBadge';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { WelloPickItem } from './WelloPickSectionServer';
type PickedGiftProps = {
  onClickItem: () => void;
  isDisplayInstitution: boolean;
  className?: string;
  priority?: boolean;
} & WelloPickItem;
export const PickedGift = t0 => {
  const $ = _c(64);
  const {
    isDisplayInstitution,
    onClickItem,
    productNumber,
    slugId,
    productName,
    imageUrl,
    isNew,
    readCount,
    institutionName,
    reviewRating,
    reviewCount,
    className,
    donationAmount,
    priority
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] !== productNumber || $[1] !== slugId) {
    t1 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[0] = productNumber;
    $[1] = slugId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${productName} 상세페이지로 이동`;
  let t3;
  if ($[3] !== donationAmount || $[4] !== imageUrl || $[5] !== institutionName || $[6] !== onClickItem || $[7] !== productName || $[8] !== productNumber || $[9] !== slugId) {
    t3 = event => {
      rememberGiftPreview({
        productNumber: slugId ?? productNumber,
        mainImageUrl: imageUrl,
        thumbnailSrc: readTappedThumbnail(event.currentTarget),
        productName,
        institutionName,
        donationAmount
      });
      onClickItem();
    };
    $[3] = donationAmount;
    $[4] = imageUrl;
    $[5] = institutionName;
    $[6] = onClickItem;
    $[7] = productName;
    $[8] = productNumber;
    $[9] = slugId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== className) {
    t4 = cn("group block w-224 shrink-0 rounded-xlarge transition-opacity duration-200 ease-out", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500", "active:opacity-80", "mobile-tablet:w-140", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("relative mb-12 h-[21.25rem] w-full", "mobile-tablet:mb-8 mobile-tablet:h-210");
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== imageUrl || $[15] !== priority || $[16] !== productName) {
    t6 = <Image fill={true} className="rounded-xlarge bg-Gray-black/10 object-cover" src={imageUrl} sizes={`${BREAKPOINTS.MOBILE_TABLET} 140px, 224px`} alt={productName} preload={priority} />;
    $[14] = imageUrl;
    $[15] = priority;
    $[16] = productName;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute inset-0 rounded-xlarge bg-gradient-to-b from-transparent from-75% to-Gray-black/40" />;
    t8 = <div aria-hidden="true" className="absolute inset-0 rounded-xlarge bg-Gray-black/0 transition-colors duration-300 ease-out group-hover:bg-Gray-black/5" />;
    $[18] = t7;
    $[19] = t8;
  } else {
    t7 = $[18];
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image src="https://cdn.welfarehello.com/static/donation/main/pick.png" alt="pick" width={45} height={24} />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isNew) {
    t10 = isNew ? <NewBadge /> : null;
    $[21] = isNew;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <div className="absolute left-0 top-0 flex items-center">{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SvgVisible className="size-14 text-Gray-white" />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== readCount) {
    t13 = readCount?.toLocaleString();
    $[26] = readCount;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <div className="absolute bottom-0 left-0 flex w-full items-center justify-center gap-2 truncate rounded-b-xlarge bg-gradient-to-t from-Gray-black/40 to-transparent pb-12">{t12}<p className="font-400 text-Gray-white typo-caption1">{t13}명이 보는 중</p></div>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t11 || $[31] !== t14 || $[32] !== t6) {
    t15 = <div className={t5}>{t6}{t7}{t8}{t11}{t14}</div>;
    $[30] = t11;
    $[31] = t14;
    $[32] = t6;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== institutionName || $[35] !== isDisplayInstitution) {
    t16 = isDisplayInstitution && <p className={cn("pb-4 font-600 text-Gray-600 typo-body4", "mobile-tablet:font-400 mobile-tablet:typo-caption1")}>{institutionName}</p>;
    $[34] = institutionName;
    $[35] = isDisplayInstitution;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn("mb-8 line-clamp-2 min-h-[2lh] font-500 text-Gray-800 typo-body3", "mobile-tablet:font-400 mobile-tablet:typo-body4");
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== productName) {
    t18 = <p className={t17}>{productName}</p>;
    $[38] = productName;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = cn("mb-2 flex items-center gap-4", "mobile-tablet:hidden");
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== donationAmount) {
    t20 = donationAmount.toLocaleString();
    $[41] = donationAmount;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="font-600 typo-body3">원</span>;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20) {
    t22 = <p className="font-700 text-Gray-black typo-body2">{t20}{t21}</p>;
    $[44] = t20;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="font-400 text-Gray-600 typo-body4">기부시 증정</p>;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t22) {
    t24 = <div className={t19}>{t22}{t23}</div>;
    $[47] = t22;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  const t25 = isDesktop ? 16 : 12;
  let t26;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      count: "typo-caption1 mt-2"
    };
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== reviewCount || $[51] !== reviewRating || $[52] !== t25) {
    t27 = <Rating value={reviewRating} count={reviewCount} size={t25} contentClassName={t26} />;
    $[50] = reviewCount;
    $[51] = reviewRating;
    $[52] = t25;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t1 || $[55] !== t15 || $[56] !== t16 || $[57] !== t18 || $[58] !== t2 || $[59] !== t24 || $[60] !== t27 || $[61] !== t3 || $[62] !== t4) {
    t28 = <CustomLink prefetch={false} href={t1} aria-label={t2} onClick={t3} className={t4}>{t15}{t16}{t18}{t24}{t27}</CustomLink>;
    $[54] = t1;
    $[55] = t15;
    $[56] = t16;
    $[57] = t18;
    $[58] = t2;
    $[59] = t24;
    $[60] = t27;
    $[61] = t3;
    $[62] = t4;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  return t28;
};